/**
 * Promotion helpers backed by the `promotionsV2` field on TerritoryInterface.
 *
 * A niche can be promoted into its own industry topic (N1). The territories
 * subgraph exposes every promotion link on `promotionsV2`; a territory is a
 * promoted industry (N1) when it is the `target` of one of its own links.
 */

/**
 * The raw id of a territory reference, dropping the `<type>.` prefix. The same
 * topic is addressed both as `topic.<id>` (insights_api) and
 * `industry_topic.<id>` (a promotion target), so comparisons must be by raw id.
 * @param {string} territoryId
 * @returns {string}
 */
const rawTerritoryId = territoryId =>
  typeof territoryId === "string" && territoryId.includes(".")
    ? territoryId.slice(territoryId.indexOf(".") + 1)
    : territoryId

/**
 * The promotion link where this territory is the target (its own N1 promotion).
 * @param {Object} territory - entity carrying `territoryId` and `promotionsV2`
 * @returns {Object | null}
 */
export const getPromotionAsTarget = territory => {
  const ownId = rawTerritoryId(territory?.territoryId)

  if (!ownId) return null

  return (
    territory?.promotionsV2?.find(
      promotion => rawTerritoryId(promotion?.target?.territoryId) === ownId
    ) || null
  )
}

/**
 * Whether a territory (topic/list row) is a promoted industry (N1).
 * @param {Object} territory
 * @returns {boolean}
 */
export const isPromotedIndustry = territory =>
  Boolean(getPromotionAsTarget(territory))
